import React, { useState } from 'react';
import Backend from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import { useSelector } from 'react-redux';
import { DragHandle, DropArea } from '../../../common/DragNDrop.jsx';
import { FaIcon } from '../../../common/Icons.jsx';
import styles from '../../settings_sidebar/common/ListGroupItem.module.scss';
import tabContainerStyles from './TabContainerWidget.module.scss';
import TextInput from '../../../common/TextInput.jsx';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import { cloneDeep } from 'lodash';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import Button from '../../../bootstrap/Button.jsx';
import { useTabContainer } from '../../hooks/useTabContainer.js';

const DND_ITEM_TYPE = '#tab';

function TabNameEdit({ editingId, widgetId, setEditingId, tab, tabs }) {
  const [value, setValue] = useState(tab.name || '')
  const setAttribute = useSetWidgetAttribute(widgetId);
  const editing = editingId === tab.id;

  const setName = name => {
    if (!name) return;
    const selectedTabs = cloneDeep(tabs)
      .map(t => ({
        ...t,
        ...(editingId == t.id && {name})
      }))
    setAttribute(`settings.tabs`, selectedTabs);
  }

  const toggleEditing = () => {
    if (editingId === tab.id) {
      setName(value)
      setEditingId(null);
    } else {
      setEditingId(tab.id);
    }
  }

  return (
    <div className={styles['title-edit']}>
      <h4 className='text-truncate'>
        {editing
          ? <TextInput value={value} onChange={e => setValue(e.target.value)} style={{height: 20, width: 'calc(100% - 2.5rem)'}} />
          : (tab.name || I18n.t('unnamed'))
        }
        <a onClick={toggleEditing}>
          <FaIcon type={editing ? 'check' : 'pencil'} />
        </a>
      </h4>
    </div>
  )
}

const TabContainerWidgetSettings = ({widgetId}) => {
  const tabs = useSelector(state => state.dashboard.widgets[widgetId].settings?.tabs || []);
  const [editingId, setEditingId] = useState(null);
  const { moveTab, removeTab, addTab } = useTabContainer({widgetId});

  return (<>
    <hr />
    <CollapsibleSection title={I18n.t('content_settings')}>
        <DndProvider backend={Backend} context={window}>
          <ul className={`list-group ${styles['list-group']}`}>
            {tabs.map((s, idx) => (
              <DropArea
                key={idx}
                accept={DND_ITEM_TYPE}
                item={{type: DND_ITEM_TYPE, index: idx}}
                onMove={moveTab}
                render={({ dropRef, dragRef, isDragging }) => {
                  return (
                    <div ref={dropRef} key={idx} className={`list-group-item dragHandle ${styles['list-group-item']} ${isDragging ? styles['dragging']: ''}`}>
                      <DragHandle dragRef={dragRef} sortHandleClass={`${styles['sort-handle']} ${tabContainerStyles['sort-handle']}`} />
                      <div className={styles['list-group-item-content']} style={{width: 'calc(100% - 2.5rem)'}}>
                        <div className={styles['list-group-item-description']} style={{margin: 0}}>
                          <TabNameEdit
                            editingId={editingId}
                            key={s.id}
                            widgetId={widgetId}
                            tab={s}
                            setEditingId={setEditingId}
                            tabs={tabs}
                          />
                        </div>
                        <div className={styles['list-group-item-actions']} style={{justifyContent: 'flex-end'}}>
                          <a onClick={() => removeTab(s.id)}>
                            <FaIcon type='trash' className='text-danger' />
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                }
              />
            ))}
          </ul>
        </DndProvider>
        <div className={styles['action-button-container']}>
          <Button size='sm' onClick={addTab}>
            <FaIcon type='plus' /> {I18n.t('add_tab')}
          </Button>
        </div>
    </CollapsibleSection>
  </>)
}

export default TabContainerWidgetSettings;